import * as i from 'types';
import styled from 'styled-components';

import { getColor } from 'styles/utils';

export const ContentBlock = styled.div<ContentBlockProps>`
  background-color: ${({ theme, variant }) => getColor(theme, variant || 'white')};
  padding: ${({ hasSmallPadding, padding }) => padding ? padding : hasSmallPadding ? '10px 0' : '100px 0'};
`;

type ContentBlockProps = {
  hasSmallPadding?: boolean;
  variant?: i.ThemeColors | [i.ThemeColors, i.SubThemeColors[i.ThemeColors]];
  padding?: string;
};
